import React from 'react'
import { Link } from 'react-router-dom'

import lauraImage from '../../images/laura-about-1.svg'
import lauraImage2 from '../../images/laura-about-2.svg'
import paws2 from '../..//images/paws-2.svg'

const About = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-12">
                        <div className="section-title text-center" style={{ paddingTop: '60px' }}>
                            <span>À propos de moi</span>
                            <h2>Laura Perillo - Votre partenaire pour l'éducation et le comportement canin</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wraper">
                <div className="left">
                    <div className="image-gallery">
                        <div className="gallery-background">
                            <svg width="793" height="786" viewBox="0 0 793 786" fill="none">
                                <path
                                    d="M84.9007 505.664C-181.681 609.802 245.585 843.801 512.633 772.246C713.751 718.356 833.104 511.631 779.214 310.513C725.325 109.395 552.6 -41.9576 351.482 11.9319C150.364 65.8214 351.482 401.526 84.9007 505.664Z"
                                    fill="#ACE7E7" />
                            </svg>
                        </div>
                        <div className="image main-image">
                            <img src={lauraImage} alt="Laura Perillo - Éducatrice canine professionnelle" />
                        </div>
                        <div className="image secondary-image">
                            <img src={lauraImage2} alt="Laura Perillo avec un chien" />
                        </div>
                    </div>
                </div>
                <div className="right">
                    <p>
                        Depuis toujours, les animaux font partie intégrante de ma vie. Parmi eux, les chiens occupent une place toute particulière : leur sensibilité, leur intelligence et leur capacité à créer un lien fort avec l’humain m’ont toujours fascinée. Cette passion m’a naturellement poussée à approfondir mes connaissances, pour accompagner les chiens et leurs humains.
                    </p>
                    <p>
                        J'ai suivi une première formation auprès de <strong>l'Animal Behavior Center</strong>, qui m'a permis d'acquérir de solides bases en éducation canine et en compréhension du comportement animal. Soucieuse de continuer à me perfectionner et à élargir mes compétences, je poursuis actuellement une formation complémentaire avec <strong>Le Monde d'Emi</strong>, reconnue pour son approche bienveillante et respectueuse.
                    </p>
                    <p>
                        Mon objectif est clair : <strong>aider les chiens et leurs familles à mieux se comprendre.</strong> J'accompagne les propriétaires aussi bien dans :
                    </p>
                    <p>
                        • <strong>L’éducation</strong> : préparer l’arrivée d’un chiot ou d’un chien adopté, poser les bases (marche en laisse, rappel, propreté…), renforcer la complicité du quotidien, ou encore mettre en place une rééducation adaptée en cas de difficultés.<br />
                        • <strong>Les problématiques comportementales</strong> : aboiements excessifs, destructions, anxiété, peurs, mauvaise gestion de la solitude, réactivité envers les congénères ou les humains, comportements agressifs…
                    </p>
                    <p>
                        Mon approche repose sur l’écoute, le respect et l’adaptation à chaque binôme chien-humain. Chaque chien étant unique, je propose des solutions personnalisées, toujours dans le but de favoriser une relation harmonieuse et équilibrée.
                        Que vous cherchiez à poser des bases solides, à corriger certains comportements, ou simplement à enrichir la complicité avec votre chien, je mets mon savoir-faire et ma passion à votre service.
                    </p>
                    <div className="about-btn">
                        <Link onClick={ClickHandler} to="/contact" className="theme-btn-s2">Me contacter</Link>
                    </div>
                </div>
            </div>
            <div className="shape-2">
                <img src={paws2} alt="" />
            </div>
        </section>
    )
}

export default About;


